export default __webpack_public_path__ + "static/media/minicard10.8ea9c9e4.jpg";